import React, { Component } from "react"
import PropTypes from "prop-types"
import { withRadium, DetectCompact, Specs, SearchParams } from "higher-order-components"
import { ColumnGroup, Column } from "containers"
import { GradePicker } from "AtomicContainers"
import { SpecificationList } from "containers"
import { LoaderIcon } from "components"
import { get } from "utils"

const apiMapping = stateOptions => ({
  nameplate: stateOptions.nameplate.name,
  bodystyle: stateOptions.bodyStyle.name,
  grade: stateOptions.grade.name,
  drivetrain: stateOptions.drivetrain.name
})

const getNameIfDefault = option => option && get("name", option)
const stateToParamsMapping = options => ({
  bodyStyle: getNameIfDefault(options.bodyStyle),
  drivetrain: getNameIfDefault(options.drivetrain),
  grade: getNameIfDefault(options.grade),
  transmission: getNameIfDefault(options.transmission),
  engine: getNameIfDefault(options.engine),
  color: getNameIfDefault(options.color),
  interiorDesign: getNameIfDefault(options.interiorDesign)
})

// Specification block component
class SpecificationsBlock extends Component {
  constructor(props) {
    super(props)
    this.state = {
      specifications: false,
      isLoading: true
    }
  }

  static propTypes = {
    heading: PropTypes.string,
    gradePickerData: PropTypes.object,
    specsApiEndpoint: PropTypes.string,
    specifications: PropTypes.object,
    initialResults: PropTypes.array,
    search: PropTypes.shape({
      query: PropTypes.object,
      pushParam: PropTypes.func
    })
  }
  componentWillMount() {
    const { specifications, initialResults, specsApiEndpoint } = this.props
    specifications.setOptions({
      mapping: apiMapping,
      initial: initialResults && { categories: initialResults },
      fetchURL: specsApiEndpoint,
      featured: false
    })
  }
  componentDidMount() {
    this.setState({ isLoading: false })
  }
  getSpecs = (options = {}) => {
    const { update } = this.props.specifications
    let updateOptions = options
    if (this.earlyUpdate) {
      updateOptions = this.earlyUpdate
      this.earlyUpdate = false
    }
    const updatePromise = update(updateOptions)
    if (!updatePromise) this.earlyUpdate = options
    else this.props.search.pushParam(stateToParamsMapping(updateOptions))
  }
  /**
   * @param {String} heading - Heading text.
   * @param {String} specsApiEndpoint - Api enpoint url for full specifications.
   * @param {Object} gradePickerData - Object containing grade picker selection tree.
   * @returns {ReactElement} React Component
   */
  render() {
    const { specifications, heading, gradePickerData } = this.props
    return (
      <ColumnGroup style={{ minHeight: "70vh" }}>
        <Column textAlignMobile="left">
          {this.state.isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "3em"
              }}>
              <LoaderIcon />
            </div>
          ) : (
              <div>
                <GradePicker
                  heading={heading}
                  onChange={this.getSpecs}
                  initialParams={this.props.search.query}
                  data={gradePickerData} />
                {specifications.loading && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "3em"
                    }}>
                    <LoaderIcon />
                  </div>
                )}
                {!specifications.loading &&
                  specifications.data && <SpecificationList specs={specifications.data.categories} />}
              </div>
            )}
        </Column>
      </ColumnGroup>
    )
  }
}

export default withRadium(
  DetectCompact(),
  SearchParams({
    exposeParams: [
      "bodyStyle",
      "drivetrain",
      "grade",
      "transmission",
      "engine",
      "color",
      "interiorDesign"
    ]
  }),
  Specs({ expose: "specifications" })
)(SpecificationsBlock)



// WEBPACK FOOTER //
// ./src/containers/specifications-block/index.jsx